import React, { useState, useContext } from 'react';
import { EWContext } from "../../../../context/EWContext";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import EligibilityQuestions from '../EligibilityQuestions';
import EligibilitySectionCard from "../EligibilitySectionCard/EligibilitySectionCard";
import { getFormAnswers } from "../../../../utils/utils";

const CustomButton = withStyles(() => ({
  root: {
    width: "100%"
  }
}))(Button);

const useStyles = makeStyles(() => ({
  box: {
    height: 90,
    display: "flex"
  },
  centerBox: {
    justifyContent: "center",
    alignItems: "center"
  }
}));

const renameQuestions = (questions, newId) => {
  return questions.map((question) => {
    const newQuestion = {
      ...question,
      id: `${question.id}_${newId}`,
      name: `${question.name}_${newId}`,
      label: `${question.label} ${newId}`,
      position: 100 + newId,
    }
    return newQuestion;
  })
}

export default function AddMoreFieldsButton(props) {
  const { question } = props;
  const [accountState, setAccountState] = useContext(EWContext);
  const { sections, sectionsAnswers } = accountState;
  const [ clicksCount, setClicksCount] = useState(Object.keys(sections[question.group] || {}).length);
  const classes = useStyles();
  const onClickButton = () => {
    setClicksCount((prevState) => prevState + 1);
    if (clicksCount >= question.field.maxDuplications) {
      return;
    }
    const arrSections = Object.keys(sections[question.group] || {});
    const sectionId = parseInt((arrSections.pop() || 1)) + 1;
    const questionsRenamed = renameQuestions(question.field.questions, sectionId);
    
    setAccountState((prevAccountState) => {
      if (prevAccountState.questions[question.group]) {
        let newSections = prevAccountState.sections[question.group]?.[sectionId] ? [...prevAccountState.sections[question.group][sectionId], ...questionsRenamed] : questionsRenamed;
        return {
          ...prevAccountState,
          sections: {
            [question.group]: {
              ...prevAccountState.sections[question.group],
              [sectionId]: newSections
            }
          }
        }
      }
      return prevAccountState;
    });
    //handleOnClick(question, clicksCount);
  }

  const handleRemoveSection = (idSection) => {
    const arrSections = Object.keys(sections[question.group] || {});
    setClicksCount(arrSections.length - 1);
    setAccountState((prevAccountState) => {
      const oldSections = prevAccountState.sections[question.group];
      const oldAnswers = prevAccountState.sectionsAnswers[question.group];
      delete oldSections[idSection];
      if (oldAnswers?.[idSection]) {
        delete oldAnswers[idSection];
      }
      return {
        ...prevAccountState,
        sections: {
            [question.group]: oldSections,
          },
        sectionsAnswers: {
            [question.group]: oldAnswers,
          }
        }
    });
  }

  const handleOnFormAnswered = (answers, lastFieldModified, idSection) => {
    const sectionQuestions = sections[question.group]?.[idSection];
    const formAnswers = getFormAnswers(answers, sectionQuestions);
    setAccountState((prevAccountState) => ({
        ...prevAccountState,
        sectionsAnswers: {
          [question.group]: {
            ...prevAccountState.sectionsAnswers[question.group],
            [idSection]: formAnswers
          }
        }
    }));
};

  const getSections = (sections) => {
    const arrSections = Object.keys(sections || {});
    return arrSections.map(section => {
      return <Grid
              item
              xs={12}
              key={`item_section_${question.id}_${question.position}_${section}`}
            >
              <EligibilitySectionCard idSection={section} onClickTopIcon={handleRemoveSection}>
                <EligibilityQuestions
                  answers={sectionsAnswers[question.group]?.[section]}
                  questions={sections[section]}
                  onFormAnswered={handleOnFormAnswered}
                  idSection={section}
                />
              </EligibilitySectionCard>
            </Grid>
    });
  }

  return (
    <React.Fragment>
     {getSections(sections[question.group])}
      <Grid
        item
        xs={12}
        key={`item_${question.id}_${question.position}`}
      >
        <Box
          component="div"
          m={1} //margin
          className={`${classes.centerBox} ${classes.box}`}
        >
          <CustomButton
            variant="contained"
            color="primary"
            id={question.id}
            disabled={clicksCount >= question.field.maxDuplications}
            onClick={onClickButton}
          >
            {question.label}
          </CustomButton>
        </Box>
      </Grid>
    </React.Fragment>
  );
}
